import React, { useRef, useEffect, useState } from "react";
import SignaturePadLib from "signature_pad";
import { Box, Button, Stack } from "@mui/material";

const SignaturePad = ({ onSave }) => {
  const canvasRef = useRef(null);
  const signaturePadRef = useRef(null);
  const [isEmpty, setIsEmpty] = useState(true);

  const penColors = [
    "#003366", // deep blue
    "#0055A4", // medium blue
    "#0077CC", // bright blue
    "#3399FF", // soft blue
    "#66B2FF", // very light blue
    "#000000", // pure black
    "#222222"  // charcoal black
  ];

  const initSignaturePad = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    // Ensure canvas has real size
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    const width = canvas.offsetWidth;
    const height = canvas.offsetHeight;
    canvas.width = width * ratio;
    canvas.height = height * ratio;
    
    const ctx = canvas.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    const randomPenColor = penColors[Math.floor(Math.random() * penColors.length)];

    signaturePadRef.current = new SignaturePadLib(canvas, {
      minWidth: 1,
      maxWidth: 2.5,
      penColor: randomPenColor,
      backgroundColor: "white"
    });

    // ✅ Proper event binding
    signaturePadRef.current.addEventListener("endStroke", () => {
      console.log("Empty:", signaturePadRef.current.isEmpty());
      setIsEmpty(signaturePadRef.current.isEmpty());
      if (!signaturePadRef.current.isEmpty()) {
          handleSave();
      }
    });
  };

  useEffect(() => {
    // ✅ Delay ensures dialog has rendered
    /*const timer = setTimeout(initSignaturePad, 250);

    return () => clearTimeout(timer);*/
    const init = () => {
        const canvas = canvasRef.current;
        const ratio = Math.max(window.devicePixelRatio || 1, 1);

        // internal DPI fix
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;

        const ctx = canvas.getContext("2d");
        ctx.scale(ratio, ratio);

        // REQUIRED white background
        //ctx.fillStyle = "#ffffff";
        //ctx.fillRect(0, 0, canvas.width, canvas.height);

        
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // random color choice
        const penColors = [
            "#003366", "#0055A4", "#0077CC",
            "#3399FF", "#66B2FF",
            "#000000", "#222222"
        ];
        const penColor = penColors[Math.floor(Math.random() * penColors.length)];

        signaturePadRef.current = new SignaturePadLib(canvas, {
            minWidth: 1,
            maxWidth: 2.5,
            penColor,
            backgroundColor: "rgba(0, 0, 0, 0)"
        });

        setTimeout(() => {
          signaturePadRef.current.addEventListener("endStroke", () => {
            console.log("Empty:", signaturePadRef.current.isEmpty());
            setIsEmpty(signaturePadRef.current.isEmpty());
            if (!signaturePadRef.current.isEmpty()) {
                handleSave();
            }
          });
        }, 250)
    };

    setTimeout(init, 250); // allows modal to render
  }, []);

  const handleClear = () => {
    signaturePadRef.current.clear();
    setIsEmpty(true);
  };

  const handleSave = () => {
    if (signaturePadRef.current.isEmpty()) return;
    const dataUrl = signaturePadRef.current.toDataURL("image/png");
    onSave(encodeURIComponent(dataUrl));
  };

  return (
    <Box>
      <Box
        sx={{
          border: "2px dashed #444",
          borderRadius: "8px",
          width: "100%",
          height: "220px",
          background: "#fff",
          position: "relative"
        }}
      >
        <canvas
          ref={canvasRef}
          style={{
            width: "100%",
            height: "100%",
            touchAction: "none",
            pointerEvents: "auto"   // ✅ ensures event capture
          }}
        />
      </Box>

      <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
        <Button variant="outlined" onClick={handleClear}>
          Clear
        </Button>
      </Stack>
    </Box>
  );
};

export default SignaturePad;
